var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateAttendance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.25C18.0888 19.25 20.1875 17.1513 20.1875 14.5625C20.1875 11.9737 18.0888 9.875 15.5 9.875C12.9112 9.875 10.8125 11.9737 10.8125 14.5625C10.8125 17.1513 12.9112 19.25 15.5 19.25Z",
    stroke: "#6D5F85",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97656 23.864C8.68193 22.4746 9.75823 21.3078 11.0862 20.4927C12.4141 19.6776 13.9418 19.2461 15.5 19.2461C17.0582 19.2461 18.5859 19.6776 19.9138 20.4927C21.2418 21.3078 22.3181 22.4746 23.0234 23.864",
    stroke: "#6D5F85",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.125 7.0625H26.75",
    stroke: "#6D5F85",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9375 4.25V9.875",
    stroke: "#6D5F85",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5949 13.625C26.9904 15.9751 26.6288 18.39 25.5623 20.5211C24.4959 22.6522 22.7797 24.3892 20.6616 25.4813C18.5435 26.5735 16.1332 26.9642 13.7786 26.5971C11.4239 26.23 9.24693 25.124 7.56185 23.439C5.87677 21.7539 4.77083 19.5769 4.40372 17.2222C4.03661 14.8676 4.42733 12.4573 5.51946 10.3392C6.6116 8.22111 8.34862 6.50493 10.4797 5.43846C12.6108 4.37198 15.0257 4.01039 17.3758 4.40591",
    stroke: "#6D5F85",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAttendance);
export default __webpack_public_path__ + "static/media/create_attendance.66615d7b31ec6a05c76ee2f25665b44a.svg";
export { ForwardRef as ReactComponent };